module.exports = __webpack_public_path__ + "static/media/Banner-promo-M-Rayados-V4.98735c8b.png";